import axios from '../http.js'

//用户信息
function getCurrUserInfo() {
  return axios.baseAxios({
    url: '/backstage/auth/getCurrUserInfo',
    method: 'get'
  })
}
//检查是否登陆
function checkLogin() {
  return axios.baseAxios({
    url: '/backstage/authUser/checkLogin',
    method: 'get'
  })
}

//查询学院树
function getCollegeTree(data) {
  return axios.baseAxios({
    url: '/backstage/sysDepartment/queryCollegeTree',
    method: 'get',
    params: data
  })
}
//根据当前用户所属部门查询树形结构数据
function getDeptTree(data) {
  return axios.baseAxios({
    url: '/backstage/sysDepartment/listTree',
    method: 'post',
    params: data
  })
}
//用户分页
function getUserList(data) {
  return axios.baseAxios({
    url: '/backstage/sys/user/listPage',
    method: 'post',
    params: data
  })
}


export default {
  getCurrUserInfo,
  checkLogin,
  getCollegeTree,
  getDeptTree,
  getUserList
}


// WEBPACK FOOTER //
// ./src/api/modules/common.js